import PropTypes from 'prop-types';
import DesktopSidebar from './DesktopSidebar';
import MobileBottomNav from './MobileBottomNav';

function FeedLayout({ children }) {
  return (
    <div className="min-h-screen bg-puzzle-background">
      <DesktopSidebar />
      <MobileBottomNav />

      {/* Main content area with proper padding for navigation */}
      <main className="md:pl-sidebar-collapsed xl:pl-sidebar pb-12 md:pb-0">
        {children}
      </main>
    </div>
  );
}

FeedLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FeedLayout;
